import { render, staticRenderFns } from "./BudgetIncrease.vue?vue&type=template&id=b983347e"
import script from "./BudgetIncrease.vue?vue&type=script&lang=js"
export * from "./BudgetIncrease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports